// NEW WORKING SIDEBAR (React Router v6)
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { svgIcon } from '../../Functions';
import BottomNavigation from './bottom-navigation';
import { withRouter } from './withRouter';
import { GetNavigations } from '../../Functions/functions';

class Sidebar extends Component {

    toggleAccordion(e) {
        let parent = e.currentTarget.parentNode;
        parent.classList.toggle("open");
    }

    toggleSubAccordion = (e) => {
        let parent = e.currentTarget.parentNode;
        parent.classList.toggle("open");
    }

    gotoPage(pageNo) {
        const { router, pdf, isPublish, com_slug } = this.props;
        const { navigate } = router;

        const { pdfSlug } = pdf;

        pageNo = Number(pageNo);
        var Url = `/${pdfSlug}/page/${pageNo}`;

        if (isPublish && com_slug) {
            Url = `/${com_slug}/${pdfSlug}/page/${pageNo}`;
        }


        navigate(Url);              // <-- FIX: React Router v6 navigation
        this.props.toggleSidebar();
    }

    _render = () => {
        const { menuData } = this.props;
        if (!menuData || typeof menuData !== 'object') return null;

        return menuData.map((m, i) => {
            if (m.children && m.children.length > 0) {
                const children = m.children.map((c, j) => {
                    if (c.children && c.children.length > 0) {

                        const subChild = c.children.map((subData, index) => (
                            <li key={`subc_${index}_${j}`}>
                                <span onClick={() => this.gotoPage(subData.pageNo)}>
                                    {subData.title}
                                </span>
                            </li>
                        ));

                        return (
                            <li className="hassubChild" key={`subd_${j}`}>
                                <span className="title" onClick={this.toggleSubAccordion}>
                                    {c.title}
                                </span>
                                <span className="accordion-subarrow" onClick={this.toggleSubAccordion}>
                                    {svgIcon('ico-arrowRight')}
                                </span>
                                <ul className="accordion-sub-child">
                                    {subChild}
                                </ul>
                            </li>
                        );
                    }

                    return (
                        <li key={c.pageNo}>
                            <span
                                className="title"
                                onClick={() => this.gotoPage(c.pageNo)}
                            >
                                {c.title}
                            </span>
                        </li>
                    );
                });

                return (
                    <li className="hasChild" key={`d_${i}`}>
                        <span className="title" onClick={this.toggleAccordion}>
                            {m.title}
                        </span>
                        <span
                            className="accordion-arrow"
                            onClick={this.toggleAccordion}
                        >
                            {svgIcon('ico-arrowRight')}
                        </span>

                        <ul className="accordion-child">
                            {children}
                        </ul>
                    </li>
                );
            }

            return (
                <li key={m.pageNo}>
                    <span className="title" onClick={() => this.gotoPage(m.pageNo)}>
                        {m.title}
                    </span>
                </li>
            );
        });
    };

    render() {
        const sidebarClass = this.props.isSidebarOpen ? 'app-sidebar open' : 'app-sidebar';

        return (
            <div className={sidebarClass}>
                <div className="scrollable-list privacyCookieSidebarMain">

                    <ul className="accordion">
                        {this._render()}
                    </ul>

                    {this.props.cookiePolicyData && (
                        <ul className="accordion forPrivacyPolicyMain">
                            <li>
                                <span className="title">
                                    <Link to={GetNavigations("/privacy")}>Privacy Policy</Link>
                                </span>
                            </li>
                            <li>
                                <span className="title">
                                    <Link to={GetNavigations("/cookie")}>Cookie Policy</Link>
                                </span>
                            </li>
                        </ul>
                    )}

                </div>
            </div>
        );
    }
}

export default withRouter(Sidebar);
